import { AppState } from 'types/app';
import { CSDropdown } from 'types/navigation';

const getHeaderFooter = (state: AppState) => state.headerFooter;

export const getIsMobile = (state: AppState) => getHeaderFooter(state).isMobile;

export const getOpenedNav = (state: AppState) => getHeaderFooter(state).openedNav;

export const getOpenedSubNav = (state: AppState) => getHeaderFooter(state).openedSubNav;

const getHeaderContent = (state: AppState) => getHeaderFooter(state).content.Header;

export const getHeaderSlotData = (slot: string, state: AppState) => getHeaderContent(state).slotData[slot];

export const getCustomerServiceMenu = (state: AppState): CSDropdown => getHeaderSlotData('customer-service-menu', state);
